import { FC } from 'react';

import { FormSubmit } from 'libs/form/Form';
import { useTranslation } from 'libs/i18n';

import {
  Form,
  LegalClientHeadFormType,
  getSchema,
} from '../../forms/legalClientHeadForm';

import { FormContent, FormContentProps } from './FormContent';

export interface LegalClientHeadFormProps extends FormContentProps {
  initialValues?: LegalClientHeadFormType;
  onSubmit: FormSubmit<LegalClientHeadFormType>;
}

export const LegalClientHeadForm: FC<LegalClientHeadFormProps> = ({
  initialValues,
  onSubmit,
  ...formProps
}) => {
  const { t } = useTranslation();

  const schema = getSchema(t);

  return (
    <Form
      initialReadOnly
      initialShowCopyButton
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </Form>
  );
};
